import React from 'react';
import { Flex, Layout } from 'antd';
const { Footer } = Layout;
import { VERSION } from '../../../../resources';
import { useSelector } from 'react-redux';

const FooterLayout = () => {
  const userProfile = useSelector((state) => state.info);
  return (
    <Footer
      style={{
        textAlign: 'center',
        width: '100vw',
        height: '6vh',
        padding: '0px',
        position: 'fixed',
        bottom: 0,
      }}
    >
      <Flex vertical style={{ width: '100%', height: '100%' }} justify={'center'} align={'center'}>
        <div>รหัสลูกค้า: {userProfile?.dealerCode}</div>
        <div>ZettaSoft @2024 {VERSION}</div>
      </Flex>
    </Footer>
  );
};

export default FooterLayout;
